@let internalComments = commentsInternal();

<div class="flex flex-row items-center justify-center flex-wrap">
  <div class="w-full">
    @if (internalComments) {
      <div>
        @for (c of internalComments; track c.created_at) {
          <app-comment [userName]="c.user_name" [dateCreated]="c.created_at" [text]="c.content" [mode]="mode()"></app-comment>
        }
      </div>
    }

    <div class="mb-2"></div>

    @if (mode() === "normal") {
      <app-comment-input
        [cancellationId]="cancellationId()"
        (commentSubmitEnd)="handleCommentSubmitEnd()"
        (commentSubmitStart)="handleCommentSubmitStart()"
      ></app-comment-input>
    }
  </div>
</div>
